// links
export const MD5_LINK = "/md5";
export const SHA256_LINK = "/sha256";
export const BASE64_ENCODE_LINK = "/base64_encode";
export const BASE64_DECODE_LINK = "/base64_decode";

// page layout 
export const TITLE = "Frin Encoder";

// text constants
export const MD5_BUTTON = "md5";
export const SHA256_BUTTON = "sha256";
export const BASE64_ENCODE_BUTTON = "b64e";
export const BASE64_DECODE_BUTTON = "b64d";

// component styles
export const GENERATED_HASH_STYLE = {
    border: "1px solid LightGrey",
    borderRadius: "5px",
    overflow: "auto",
    wordWrap: "break-word",
    
    "&:hover": {
        border: "1px solid Blue"
    }
}

export const GITHUB_LINK_STYLE = {
    textDecoration: "none",
    color: "inherit"
}

// outside
export const PROJECT_GITHUB_LINK = "https://github.com/satyahbp/encoder"